(function () {
  'use strict';

  function isPartnersMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function prefersSmoothScroll() {
    return (
      window.matchMedia('(hover: hover) and (pointer: fine)').matches &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function initReveal(root) {
    root = root || document;
    var els = root.querySelectorAll('.wpw-page .wp-reveal, .wpc-page .wp-reveal');
    if (!els.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || isPartnersMobile()) {
      els.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-revealed');
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
      );
      els.forEach(function (el) { io.observe(el); });
    } else {
      els.forEach(function (el) { el.classList.add('is-revealed'); });
    }
  }

  function initFaq(root) {
    root.querySelectorAll('[data-wpc-faq-toggle]').forEach(function (btn) {
      if (btn.dataset.wpcFaqBound) return;
      btn.dataset.wpcFaqBound = '1';
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-wpc-faq-item]');
        if (!item) return;
        var open = item.classList.contains('is-open');
        root.querySelectorAll('[data-wpc-faq-item].is-open').forEach(function (el) {
          el.classList.remove('is-open');
          el.querySelector('[data-wpc-faq-toggle]')?.setAttribute('aria-expanded', 'false');
        });
        if (!open) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function initStickyCta() {
    var sticky = document.querySelector('[data-wpc-sticky]');
    var target = document.querySelector('#partner-application');
    if (!sticky || !target) return;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
        },
        { threshold: 0.05 }
      );
      io.observe(target);
    }
  }

  function initPartnerForm() {
    var form = document.getElementById('CountryPartnerForm');
    if (!form || form.dataset.wpcFormBound) return;
    form.dataset.wpcFormBound = '1';

    form.addEventListener('submit', function () {
      var body = form.querySelector('[name="contact[body]"]');
      if (!body) return;

      var name = val('PartnerName');
      var email = val('PartnerEmail');
      var country = val('PartnerCountry');
      var city = val('PartnerCity');
      var background = val('PartnerBackground');
      var experience = val('PartnerExperience');
      var message = body.value.trim();

      var lines = [
        'Country Partner application',
        '---',
        'Name: ' + name,
        'Email: ' + email,
        'Target country: ' + country,
        'City & timezone: ' + city,
        'Background: ' + background,
        'Market experience: ' + experience,
        '---',
        message || '(no additional message)'
      ];

      body.value = lines.join('\n');

      ['PartnerCountry', 'PartnerCity', 'PartnerBackground', 'PartnerExperience'].forEach(function (id) {
        var el = document.getElementById(id);
        if (el) el.removeAttribute('name');
      });
    });

    function val(id) {
      var el = document.getElementById(id);
      return el ? el.value.trim() : '';
    }
  }

  function initTerritoryPicker() {
    document.querySelectorAll('[data-wpc-territory]').forEach(function (btn) {
      if (btn.dataset.wpcTerritoryBound) return;
      btn.dataset.wpcTerritoryBound = '1';
      btn.addEventListener('click', function () {
        var country = btn.getAttribute('data-wpc-territory');
        var field = document.getElementById('PartnerCountry');
        document.querySelectorAll('.wpc-territory-card.is-selected').forEach(function (el) {
          el.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');
        if (field) field.value = country;
        var form = document.getElementById('partner-application');
        if (form) {
          form.scrollIntoView({ behavior: prefersSmoothScroll() ? 'smooth' : 'auto', block: 'start' });
        }
        if (field) {
          field.focus({ preventScroll: true });
        }
      });
    });
  }

  function boot() {
    initReveal(document);
    initFaq(document);
    initStickyCta();
    initPartnerForm();
    initTerritoryPicker();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initReveal(e.target);
    initFaq(e.target);
    initPartnerForm();
    initTerritoryPicker();
  });
})();
